import React from 'react';
import { Box, TableCell, Typography } from '@mui/material';
import { KpiSimpleDto, KpiVisitasDto, VisitasPlanIndicadoresDto } from '../../../types/visitas';
import { formatCurrency } from '../../../utils/formatters';

const zeroSimple: KpiSimpleDto = { total: 0, avancePorcentaje: 0 };

export const formatPlanVisitasIndicador = (visitas?: KpiVisitasDto): string => {
  const kpi = visitas ?? { total: 0, completadas: 0, pendientes: 0, iniciadas: 0, omitidas: 0, avancePorcentaje: 0 };
  return `${kpi.completadas}/${kpi.total}`;
};

export const formatPlanCobranzasIndicador = (cobranzas?: KpiSimpleDto): string =>
  formatCurrency(cobranzas?.total ?? 0);

export const formatPlanVentasIndicador = (ventas?: KpiSimpleDto): string =>
  formatCurrency(ventas?.total ?? 0);

export const formatPlanEntregasIndicador = (entregas?: KpiSimpleDto): string => {
  const kpi = entregas ?? zeroSimple;
  const pendientes = kpi.total;
  if (pendientes <= 0) return '0/0';
  const entregados = Math.round((pendientes * kpi.avancePorcentaje) / 100);
  return `${entregados}/${pendientes}`;
};

interface PlanIndicadorCellProps {
  label: string;
  value: string;
  align?: 'left' | 'right' | 'center';
}

const PlanIndicadorCell: React.FC<PlanIndicadorCellProps> = ({ label, value, align = 'right' }) => (
  <TableCell align={align}>
    <Typography variant="caption" color="text.secondary" display="block" sx={{ lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
      {value}
    </Typography>
  </TableCell>
);

export const PlanIndicadoresTableCells: React.FC<{ plan: VisitasPlanIndicadoresDto }> = ({ plan }) => (
  <>
    <PlanIndicadorCell label="Visitas" value={formatPlanVisitasIndicador(plan.visitas)} />
    <PlanIndicadorCell label="Cobranzas" value={formatPlanCobranzasIndicador(plan.cobranzas)} />
    <PlanIndicadorCell label="Ventas" value={formatPlanVentasIndicador(plan.ventas)} />
    <PlanIndicadorCell label="Entregas" value={formatPlanEntregasIndicador(plan.entregas)} />
  </>
);

export const PlanIndicadoresMobileSummary: React.FC<{ plan: VisitasPlanIndicadoresDto }> = ({ plan }) => (
  <Box
    sx={{
      mt: 1,
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: 1,
    }}
  >
    {[
      { label: 'Visitas', value: formatPlanVisitasIndicador(plan.visitas) },
      { label: 'Cobranzas', value: formatPlanCobranzasIndicador(plan.cobranzas) },
      { label: 'Ventas', value: formatPlanVentasIndicador(plan.ventas) },
      { label: 'Entregas', value: formatPlanEntregasIndicador(plan.entregas) },
    ].map((item) => (
      <Box key={item.label}>
        <Typography variant="caption" color="text.secondary" display="block">
          {item.label}
        </Typography>
        <Typography variant="body2" fontWeight={600}>
          {item.value}
        </Typography>
      </Box>
    ))}
  </Box>
);
